import { Link, useLocation } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();
  usePageMeta('页面未找到 - 鲁啊鲁', '抱歉，你访问的页面不存在或已被移除。');

  return (
    <div className="w-full px-4 md:px-8 py-20 text-center">
      <div className="relative">
        <span className="font-heading text-8xl md:text-9xl font-black text-primary-100 select-none">404</span>
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-600">
            <i className="ri-compass-3-line text-3xl"></i>
          </span>
        </span>
      </div>
      <h1 className="mt-6 text-2xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的地址 <span className="text-foreground-700">{location.pathname}</span> 不存在或已被移除。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
        >
          <i className="ri-home-5-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-5 py-2.5 text-sm font-medium text-foreground-600 hover:border-primary-300 hover:text-primary-700 transition-colors"
        >
          <i className="ri-search-line"></i>
          前往搜索
        </Link>
      </div>
    </div>
  );
}